import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const Statuses = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'statuses' */
  './Statuses'
))

export function AsyncStatuses(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Statuses..." />}>
      <Statuses {...props} />
    </Suspense>
  )
}

export default AsyncStatuses
